export default "assets/images/logo-lion-white-e0e231a8.svg";